import { render, staticRenderFns } from "./RegionalMarketingManagement.vue?vue&type=template&id=2f04603c&scoped=true"
import script from "./RegionalMarketingManagement.vue?vue&type=script&lang=js"
export * from "./RegionalMarketingManagement.vue?vue&type=script&lang=js"
import style0 from "./RegionalMarketingManagement.vue?vue&type=style&index=0&id=2f04603c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04603c",
  null
  
)

export default component.exports